'use strict';

var $ = require('jquery');
var basePage = require('../pages/base-page.js');
var layout = require('../ui/layout.js');
var scroll = require('../ui/scroll.js');
var analytics = require('../utils/analytics.js');

var classNames = {
    actionBox: 'action-box'
};

function logPanelSwitchEvent(currentPanel, newPanel) {
    if (currentPanel !== newPanel) {
        analytics.trackEvent('Van homepage uber-tab', 'Tab change', currentPanel + ' -> ' + newPanel);
    }
}

function togglePanels($targetPanel) {
    var $otherPanels = $targetPanel.siblings();
    var $container = $.findByBem(classNames.actionBox);
    var currentActivePanel = $container.data('active-panel');
    var newActivePanel = $targetPanel.data('panel');

    logPanelSwitchEvent(currentActivePanel, newActivePanel);

    if (layout.isMobile()) {
        $otherPanels.removeBemClass(classNames.actionBox, 'panel', 'active').findByBem(classNames.actionBox, 'panel__content').hide();
        $targetPanel.addBemClass(classNames.actionBox, 'panel', 'active').findByBem(classNames.actionBox, 'panel__content').slideDown();
        scroll.scrollTo($targetPanel, 400);
    } else {
        $otherPanels.removeBemClass(classNames.actionBox, 'panel', 'active');
        $targetPanel.addBemClass(classNames.actionBox, 'panel', 'active');

        $container.removeBemClass(classNames.actionBox, null, currentActivePanel);
        $container.addBemClass(classNames.actionBox, null, newActivePanel);
        $container.data('active-panel', newActivePanel);
    }
}

function initActionBox(context) {
    $.findByBem(classNames.actionBox, 'panel__heading', null, context).on('click.action-box-heading', function(e) {
        e.preventDefault();
        togglePanels($(this).parent());
    });

    $.findByBem(classNames.actionBox, 'panel__expander', null, context).on('click.action-box-expander', function() {
        togglePanels($(this).parent());
    });
}

 
basePage.init = function() {
	basePage.initBasePage();

	var $context = $('#vanHomePage');
    initActionBox($context);
};

module.exports = basePage;